import jsPDF from "jspdf";
import "jspdf-autotable";
import { toast } from "react-toastify";

export const generatePDF = (orderCycle) => {
    if (!orderCycle) {
      toast.error("No data available to download.");
      return;
    }

    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height; // Get page height
    const orgText = `Organization: ${orderCycle.organizationName}`;
    const locText = `Location: ${orderCycle.location}`;
    const header = `${orderCycle.orderCyclePDFHeader}`;
    const footer = `${orderCycle.orderCyclePDFFooter}`;

    const margin = 14; // Starting x position
    const spacing = 10; // Spacing between texts

    // Add Logo
    const img = new Image();
    img.src = "/logo.png"; // Ensure the logo is in the public folder
    img.onload = () => {
      doc.addImage(img, "PNG", 80, 10, 40, 40); // Center the image

      // Centered Title
      doc.setFontSize(20);
      doc.text(header, doc.internal.pageSize.width / 2, 55, { align: "center" });

      // Title
      doc.setFontSize(15);
      doc.text("Stock Overview", 14, 70);

      // Order Cycle Details
      doc.setFontSize(12);
      doc.text(orgText, margin, 80);
      doc.text(locText, margin + doc.getTextWidth(orgText) + spacing, 80);

      // Define table columns and rows
      const tableColumn = ["#", "Product Name", "Price (LKR)", "Unit"];
      const tableRows = [];

      // Sort products by category
      const sortedProducts = [...orderCycle.products].sort((a, b) =>
        a.product_category.localeCompare(b.product_category)
      );

      let lastCategory = null;
      let rowIndex = 1;

      sortedProducts.forEach((product) => {
        if (product.product_category !== lastCategory) {
          tableRows.push([
            {
              content: product.product_category,
              colSpan: 4,
              styles: { halign: "center", fontStyle: "bold", fillColor: [220, 220, 220] },
            },
          ]);
          lastCategory = product.product_category;
        }

        tableRows.push([
          rowIndex++,
          product.product_name,
          new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(product.price),
          product.unit,
        ]);
      });

      // Generate Table
      doc.autoTable({
        startY: 90,
        head: [tableColumn],
        body: tableRows,
        styles: { fontSize: 10, cellPadding: 2 },
        tableWidth: "auto",
        columnStyles: {
          0: { halign: "center" }, // Center the row index column
          1: { halign: "left" },   // Align "Product Name" to the left
          2: { halign: "right" },  // Align "Price" column to the right
          3: { halign: "center" }, // Center the "Unit" column
        },
        headStyles: {
          fillColor: [133, 201, 151], // Header background color
          textColor: [0, 0, 0], // Black text
          fontSize: 11,
          fontStyle: "bold",
        },
        didParseCell: function (data) {
          if (data.section === "head") {
            if (data.column.index === 1) {
              data.cell.styles.halign = "left"; // Ensure "Product Name" header is left-aligned
            }
            if (data.column.index === 2) {
              data.cell.styles.halign = "right"; // Ensure "Price" header is right-aligned
            }
            if (data.column.index === 0 || data.column.index === 3) {
              data.cell.styles.halign = "center"; // Ensure "Unit" header is center-aligned
            }
          }
        },
      });
      

      // Move to last page and add footer at the **bottom of the page**
      const totalPages = doc.internal.getNumberOfPages();
      doc.setPage(totalPages);

      doc.setFontSize(10);
      doc.text(footer, doc.internal.pageSize.width / 2, pageHeight - 15, { align: "center" });

      // Save PDF
      doc.save(`Stock_Overview_${orderCycle.orderCycleCode}.pdf`);
    };
  };